// tslint:disable-next-line:no-reference
/// <reference path="../../../typings/globals/cordova/index.d.ts" />

export class NativeStorageProxy {
  get<T>(key: string): Promise<T> {
    return new Promise((resolve, reject) =>
      NativeStorage.getItem(key, (value) => resolve(JSON.parse(value)), reject),
    );
  }

  getOrElse<T>(key: string, defaultValue: T): Promise<T> {
    return new Promise((resolve, reject) =>
      NativeStorage.getItem(
        key,
        (value) => resolve(JSON.parse(value)),
        (reason) => {
          console.debug(`getOrElse, promise rejected [key: ${key}]`, reason);
          resolve(defaultValue);
        },
      ),
    );
  }

  set<T>(key: string, value: T): Promise<T> {
    return new Promise((resolve, reject) =>
      NativeStorage.setItem(key, JSON.stringify(value), resolve, reject),
    );
  }

  remove(key: string): Promise<void> {
    return new Promise((resolve, reject) =>
      NativeStorage.remove(key, resolve, reject),
    );
  }

  clear(): Promise<{}> {
    return new Promise((resolve, reject) =>
      NativeStorage.clear(resolve, reject),
    );
  }

  keys(): Promise<string[]> {
    return new Promise((resolve, reject) =>
      NativeStorage.keys(resolve, reject),
    );
  }
}
